export enum RecordingState {
    Stopped = 'inactive',
    Paused = 'paused',
    Recording = 'recording'
}

export type BlobEvent = Event & {
    data: Blob;
    timeStamp: number;
    target: IMediaRecorder;
};

export interface IMediaRecorder {
    // new (stream: MediaStream, options?: {}): MediaRecorder;
    state: RecordingState;
    audioBitsPerSecond: number;
    start(timeslice?: number): void;
    stop(): void;
    pause(): void;
    resume(): void;
    onstop(): void;
    ondataavailable(e: BlobEvent): void;
    requestData(): void;
}



// WEBPACK FOOTER //
// ./src/_components/AudioRecorder/MediaRecorder.ts